/* eslint-disable promise/always-return */
/* eslint-disable no-param-reassign */
/* eslint-disable promise/catch-or-return */
/* eslint-disable promise/no-return-wrap */
import axios from 'axios';
import { Auth } from '@aws-amplify/auth';
import { getLoginUrl } from '../getLoginUrl';

const defaultBaseURL = process.env.GATSBY_API_URL || 'http://localhost:8000';

/**
 * Creates an axios instance with authentication interceptors
 * @param baseURL - Optional base URL for the axios instance. Defaults to GATSBY_API_URL or localhost:8000
 * @returns Configured axios instance with authentication interceptors
 */
export function createAxiosInstance(baseURL: string = defaultBaseURL) {
  const instance = axios.create({
    baseURL,
  });

  instance.interceptors.request.use(
    async (config): Promise<any> =>
      new Promise((resolve) => {
        Auth.currentSession()
          .then((session) => {
            const idTokenExpire = session.getAccessToken().getExpiration();
            const refreshToken = session.getRefreshToken();
            const currentTimeSeconds = Math.round(+new Date() / 1000);
            if (idTokenExpire < currentTimeSeconds) {
              Auth.currentAuthenticatedUser().then((res) => {
                res.refreshSession(
                  refreshToken,
                  (
                    err: any,
                    data: {
                      getAccessToken: () => {
                        (): any;
                        new (): any;
                        getJwtToken: { (): any; new (): any };
                      };
                    },
                  ) => {
                    if (err) {
                      Auth.signOut().then(() => {
                        localStorage.removeItem('me');
                        window.location.href = getLoginUrl(
                          typeof window !== 'undefined'
                            ? window.location.href
                            : undefined,
                        );
                      });
                      // Navigate to login gateway
                    } else {
                      config.headers.Authorization = `Bearer ${data
                        .getAccessToken()
                        .getJwtToken()}`;
                      resolve(config);
                    }
                  },
                );
              });
            } else {
              config.headers.Authorization = `Bearer ${session
                .getAccessToken()
                .getJwtToken()}`;
              resolve(config);
            }
          })
          .catch(() => {
            // No logged-in user: don't set auth header
            // TODO: send them to the login gateway
            resolve(config);
          });
      }),
  );

  return instance;
}

// Default instance for backward compatibility
const instance = createAxiosInstance();
instance.defaults.headers.common['X-Client-Id'] = 'lo-portal';

export default instance;
